import { RiTodoLine } from 'react-icons/ri';
import {
  NumberFilterCondition,
  TextFilterCondition,
  DateFilterCondition,
  CellFilterCondition,
  FilterCondition,
} from '../../../../types';
import { useRef } from 'react';

import Picker1 from '../../../../../core/components/pickers/Picker1';
import { CustomDivider } from '../../../../../core/components/pickers/types';

interface FilterConditionDropdownProps {
  condition?: FilterCondition;
  changeCondition: (condition: FilterCondition) => void;
}
export default function FilterConditionDropdown({
  condition,
  changeCondition,
}: FilterConditionDropdownProps) {
  const conditionOptions = getFilterConditionsOptions();
  const selectedRef = useRef<HTMLButtonElement | null>(null);

  const menuTitle = condition?.length ? condition.toLowerCase() : 'none';

  const menu = (
    <Picker1.Menu ref={selectedRef}>
      <Picker1.MenuButton Icon={<RiTodoLine />} title={menuTitle} />
      <Picker1.MenuList<FilterCondition>
        includeNone
        selectedRef={selectedRef}
        selectedValue={condition}
        options={conditionOptions}
        changeValue={changeCondition}
      />
    </Picker1.Menu>
  );

  return menu;
}

const getFilterConditionsOptions = (): Array<
  FilterCondition | CustomDivider
> => [
  { title: 'Cell ' },
  ...Object.values(CellFilterCondition),
  { title: 'Number ' },
  ...Object.values(NumberFilterCondition),
  { title: 'Text ' },
  ...Object.values(TextFilterCondition),
  { title: 'Date ' },
  ...Object.values(DateFilterCondition),
];
